import React, { createContext, FC, useContext, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

import { useLocation } from 'react-router-dom';


type MainLayoutContextType = {
  isMobile: boolean;
  isDrawerOpened: boolean;
  setIsDrawerOpened: React.Dispatch<React.SetStateAction<boolean>>;
};


export const MainLayoutContext = createContext<MainLayoutContextType>({
  isMobile: false,
  isDrawerOpened: true,
  setIsDrawerOpened: () => {
    throw new Error('"MainLayoutProvider" is not found in your components tree. Please configure provider correctly');
  }
});
export const useMainLayoutContext = () => useContext(MainLayoutContext);

export const MainLayoutProvider: FC = ({ children }) => {
  const theme = useTheme();
  const isSmallBreakpoint = useMediaQuery(theme.breakpoints.down('md'));
  const [ isDrawerOpened, setIsDrawerOpened ] = useState(false);

  const location = useLocation();

  React.useEffect(() => {
    // close drawer on route change on mobile
    if (isSmallBreakpoint && isDrawerOpened) {
      setIsDrawerOpened(false);
    }
  }, [ location.pathname ]);

  React.useEffect(() => {
    if (isSmallBreakpoint) {
      setIsDrawerOpened(false);
    } else {
      setIsDrawerOpened(true);
    }
  }, [ isSmallBreakpoint ]);

  const value = React.useMemo(() => ({
    isMobile: isSmallBreakpoint,
    isDrawerOpened,
    setIsDrawerOpened,
  }), [ isSmallBreakpoint, isDrawerOpened ]);

  return (
    <MainLayoutContext.Provider value={value}>
      {children}
    </MainLayoutContext.Provider>
  );
};
